<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              id="ref"
              v-resize.quiet="onResize"
              class="wrap justify-space-around form-body"
            >
              <v-col cols="12">
                <v-select
                  v-model="form.service"
                  :items="items"
                  item-value="id"
                  item-text="nombre"
                  :rules="[rules.required]"
                  label="Licencia"
                  required
                  outlined
                  @change="onchange"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.folios"
                  :rules="[rules.required]"
                  label="Folios"
                  required
                  outlined
                  readonly
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';

  export default {
    props: {
      enterpriseId: { default: '' },
    },
    data: () => ({
      form: new Form({
        service: '',
        folios: 0,
        type: 'E',
        busy: false,
      }),
      apiURL: '/api/catalogs/getAllServices',
      valid: false,
      items: [],
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Nueva Licencia',
    }),
    computed: {
      ref() { return this.form.id; },
    },
    mounted() {
      this.loadServices();
      if (this.enterpriseId) {
        this.form.enterprise_id = this.enterpriseId;
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.snackbar = true;
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        this.form.post('/api/licences/associate')
        .then(() => {
          this.$router.go(-1);
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      onchange() {
        this.form.folios = this.items.filter((item) => item.id === this.form.service)[0].cantidad;
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
      onResize() {
        this.emitValue('resize', {
        on: 'resize', id: this.ref, params: { x: window.innerWidth, y: window.innerHeight }, data: this.storeStateData, schema: this.storeStateSchema,
        });
      },
      loadServices() {
        window.axios.get(this.apiURL).then((response) => {
          this.items = response.data.items;
        });
      },
    },
  };

</script>
